import {DATE_METRICS} from "@constants";

export const DATE_FORMAT_RECEIVED = {
	[DATE_METRICS.DAILY]: 'yyyyMMdd',
	[DATE_METRICS.WEEKLY]: 'yyyyww',
	[DATE_METRICS.MONTHLY]: 'yyyyMM',
	[DATE_METRICS.YEARLY]: 'yyyy',
}

export const DATE_FORMAT = {
	[DATE_METRICS.DAILY]: 'dd MMM yyyy',
	[DATE_METRICS.WEEKLY]: "yyyy 'W'ww",
	[DATE_METRICS.MONTHLY]: 'MMM, yyyy',
	[DATE_METRICS.YEARLY]: 'yyyy',
}

export const TIME_UNIT = {
	[DATE_METRICS.DAILY]: 'day',
	[DATE_METRICS.WEEKLY]: "week",
	[DATE_METRICS.MONTHLY]: 'month',
	[DATE_METRICS.YEARLY]: 'year',
}